import { render, staticRenderFns } from "./BtnInserirDocumento.vue?vue&type=template&id=d30722e6"
import script from "./BtnInserirDocumento.vue?vue&type=script&lang=js"
export * from "./BtnInserirDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports